import Marquee from "react-fast-marquee";
import { MARQUEE } from "@/data/site";

export const EditorialMarquee = () => {
    const text = MARQUEE.repeat(4);
    return (
        <div className="editorial-marquee" data-testid="editorial-marquee">
            <Marquee speed={40} gradient={false} pauseOnHover>
                <span className="font-display text-[10vw] md:text-[6.5vw] lg:text-[5.2vw] text-[var(--ink)] px-6">
                    {text}
                </span>
            </Marquee>
        </div>
    );
};
